<template>
  <div>
    <RouterView />
    <Notifications />
    <LoadOverlay />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { useAuthStore, Notifications, LoadOverlay } from './shared-vue'
import { onMounted } from 'vue'
import { loginState } from './shared-vue/account/api';

const authStore = useAuthStore()

onMounted(async () => {
  let googleClientId = document.querySelector('meta[name=google-signin-client_id]')?.getAttribute('content')
  if (googleClientId !== undefined && googleClientId !== null && googleClientId !== '{{ google_client_id }}' && googleClientId !== 'c') {
    authStore.addGoogleClientId(googleClientId)
  }
  const response = await loginState()
  if (response.authenticated) {
    authStore.loginSuccess(response.user)
  } else {
    authStore.setLogout()
  }
})
</script>

<style>
.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.finances-table {
  border-collapse: collapse;

  &>thead {
    &>tr {
      background-color: blue;

      &>th {
        color: white;
        text-align: left;
        padding: 0.5rem 1rem;
        font-weight: normal;
      }
    }
  }

  &>tbody {
    &:nth-child(odd) {
      background-color: #f2f2f2f2;
    }

    &:nth-child(even) {
      background-color: #ffffff;
    }

    &>tr {
      &>td {
        padding: 0.5rem 1rem;
        text-align: right;

        &:first-child {
          background-color: lightblue;
          text-align: left;
        }
      }
    }
  }
}
</style>
